export default {
    sections: [
        {
            name: 'Operations',
            items: [
                {
                    name: 'Dashboard',
                    icon: 'dashboard',
                    state: 'main.dashboard'
                },
                {
                    name: 'Sensors & Connectors',
                    icon: 'panorama',
                    state: 'main.sensors.list'
                }
            ]
        },
        {
            name: 'Settings',
            items: [
                {
                    name: 'Users and Access',
                    icon: 'supervisor_account',
                    state: 'main.users-and-access'
                },
                {
                    name: 'Folders and Labels',
                    icon: 'label_outline',
                    state: 'main.folders-and-labels'
                },
                {
                    name: 'Alerts & Actions',
                    icon: 'notifications',
                    state: 'main.alerts-actions'
                }
                // ,
                // {
                //     name: 'Developer Settings',
                //     icon: 'keyboard',
                //     state: 'main.developer-settings'
                // }
            ]
        }
    ],
    removed: [
        {
            name: 'Tools',
            items: [
                {
                    name: 'Google BigQuery',
                    icon: 'cloud_queue',
                    state: 'main.google-big-query'
                },
                {
                    name: 'Grafana',
                    icon: 'panorama',
                    state: 'main.grafana'
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./app/common/layout/app-menu.js